import { render, staticRenderFns } from "./TenkeyPad.vue?vue&type=template&id=ff9f6b9e&scoped=true&"
import script from "./TenkeyPad.vue?vue&type=script&lang=js&"
export * from "./TenkeyPad.vue?vue&type=script&lang=js&"
import style0 from "./TenkeyPad.vue?vue&type=style&index=0&id=ff9f6b9e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff9f6b9e",
  null
  
)

export default component.exports